const messages = {
  step3: {
    actionBtn: "Iniciar sesión",
  },
};

export default {
  messages,
};
